'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFunction;
function isFunction(val) {
  return typeof val === 'function';
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/flux-actions/static-1.35/js/isFunction.js
// module id = 188
// module chunks = 0